import React from 'react';

import { useDataFetch } from '@core/js/hooks/useDataFetch';
import { Empty } from '@core/js/components/hocs/withRGPortlet/components/Empty';

import { fetchLoginLimitsConfig } from '@theme/js/components/main/ResponsibleGaming/RegistrationLoginLimits/fetch';

export const withLoginConfig = () => (WrappedComponent) => (props) => {
    const [{
        isLoading,
        data
    }] = useDataFetch({
        fetch: fetchLoginLimitsConfig
    });

    if (isLoading) {
        return <Empty/>;
    }

    return <WrappedComponent {...props} {...data} />;
};
